import React, { useEffect, useState } from "react";
import { errorNotification, successNotification } from "../Generic/Notifications";
import { Table, Tbody, Tcol, Thead, Trow } from "../Generic/Table";
import EmptyState from "../Generic/EmptyState";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../Generic/Loader";
import Button from "../Generic/Button";
import close from "../Assets/Close.png";
import Dropdown from "../Generic/Dropdown";
import SuccessButton from "../Generic/SuccessButton";
import { TaskTypes } from "./ReplnishmentPlanConstants";
import { createISOString, isEmpty } from "../util/util";
import { CSSTransition } from "react-transition-group";
import RepenishmentPlanService from "./Services/ReplenishmentPlanService";
import InventoryPlanService from "../InventoryPlan/Services/InventoryPlanService.js";
import UpdateInventoryPlan from "./Components/updateInventoryPlan";
import { USER_FUNCTIONALITIES, checkFunctionalityPermissions } from "../config/role.config.js";
import { INPUT_TYPE } from "../Generic/Forms/constants.js";
import Form from "../Generic/Forms/Form.js";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 2rem;
	@media (max-width: 1500px) {
		padding: 1.5rem;
	}
`;

const Header = styled.div`
	display: flex;
	font-size: 2rem;
	font-weight: 600;
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-grow: 1;
	margin: ${(props) => props.margin};
`;

const CenteredRow = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	justify-content: left;
	align-items: center;
	flex-wrap: wrap;
	gap: 1.5rem;
`;

const SpacedRow = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
`;

const Block = styled.div`
	width: max-content;
	height: auto;
	display: flex;
	gap: ${(props) => props.gap || "1rem"};
	align-items: center;
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 310;
`;

const Modal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	max-height: 80%;
	width: ${(props) => props.width || "50%"};
	min-width: 30%;
	padding: 0;
	border-radius: 10px;
	z-index: 109;
	overflow: hidden;
	@media (max-width: 1000px) {
		width: ${(props) => props.widthBefore1000};
	}
`;

const Div = styled.div`
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	gap: ${(props) => props.gap};
	overflow-y: ${(props) => props.overflowY};
	overflow-x: ${(props) => props.overflowX};
	height: ${(props) => props.height};
	max-height: ${(props) => props.maxHeight};
	min-height: ${(props) => props.minHeight};
	max-width: ${(props) => props.maxWidth};
	white-space: ${(props) => props.whiteSpace};
	border: ${(props) => props.border};
	border-radius: ${(props) => props.borderRadius};
	flex-wrap: ${(props) => props.flexWrap};
	@media (max-width: 1000px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const TaskTypeOptions = [
	{
		value: TaskTypes.UNDOCK_ALL,
		head: "Full Undock",
	},
	{
		value: TaskTypes.DOCK_ALL,
		head: "Full Replenishment",
	},
	{
		value: TaskTypes.REPLACE,
		head: "Partially Replenish ",
	},
];

const PlanDataObject = {
	taskType: "",
	assignee: "",
	startTime: "",
	endTime: "",
	scheduledDates: [],
};

function getValidDates() {
	const limit = 14;
	const yesterday = new Date().setDate(new Date().getDate() - 1);
	let validDates = [yesterday, new Date()];
	for (let i = 1; i <= limit; i++) {
		let dt = new Date();
		dt.setDate(dt.getDate() + i);
		validDates.push(dt);
	}
	return validDates;
}

function getPlanDataFormConfig({ potentialAsignees, TaskTypeOptions }) {
	return {
		section1: {
			fields: [
				{
					label: "Task Type",
					name: "taskType",
					required: true,
					type: INPUT_TYPE.SELECT,
					defaultValue: "",
					options: TaskTypeOptions,
				},
				{
					label: "Xookeeper",
					name: "assignee",
					required: true,
					type: INPUT_TYPE.SELECT,
					defaultValue: "",
					options: potentialAsignees,
				},
			],
		},
		section2: {
			fields: [
				{
					label: "Start Time",
					name: "startTime",
					required: true,
					type: INPUT_TYPE.TIME,
					defaultValue: "",
				},
				{
					label: "End Time",
					name: "endTime",
					required: true,
					type: INPUT_TYPE.TIME,
					defaultValue: "",
				},
			],
		},
		section3: {
			fields: [
				{
					label: "Schedule",
					name: "scheduledDates",
					required: true,
					type: INPUT_TYPE.DATES,
					defaultValue: "",
					componentProps: {
						includeDates: getValidDates(),
					},
				},
			],
		},
	};
}

	function updatePayloadDates(payload, timezone) {

		if(!payload.startTime) {
			throw new Error("No Start Time provided");
		}

		if(!payload.endTime) {
			throw new Error("NO End time provided");
		}

		if(!payload?.scheduledDates?.length) {
			throw new Error("No Scheduled dates provided");
		}

		let timeWindows = [];
		for (const date of payload.scheduledDates) {

			let startTime, endTime;

			try {
				startTime = createISOString(date, payload.startTime, timezone);
			} catch(error) {
				throw new Error(`Could not generate epoch startTime with arguments date - ${date}, starTime - ${payload.startTime} and timezone ${timezone} due to error ${JSON.stringify(error)}`);
			}

			try {
				endTime = createISOString(date, payload.endTime, timezone);
			} catch(error) {
				throw new Error(`Could not generate epoch endTime with arguments date - ${date}, starTime - ${payload.startTime} and timezone ${timezone} due to error ${JSON.stringify(error)}`);
			}

			timeWindows.push({ startTime, endTime });
		}

		payload.timeWindows = timeWindows;

		//Cleanup Keys
		delete payload.scheduledDates;
		delete payload.startTime;
		delete payload.endTime;
	}

const TaskManager = (props) => {
	const { machineID, activeRole, timezone } = props;

	const [taskList, setTaskList] = useState([]);
	const [loading, setLoading] = useState(true);
	const [pageError, setPageError] = useState(false);
	const [showCreatePlanModal, toggleShowCreatePlanModal] = useState(false);
	const [createModalLoading, setCreateModalLoading] = useState(false);
	const [createPlanLoading, setCreatePlanLoading] = useState(false);
	const [potentialAsignees, setPotentialAsignees] = useState([]);
	const [cancelModal, showCancelModal] = useState(false);
	const [planToCancelData, setPlanToCancelData] = useState({});
	const [inventoryPlans, setInventoryPlans] = useState([]);
	const [showAttachPlanModal, toggleAttachPlanModal] = useState(false);
	const [selectedInventoryPlan, setSelectedInventoryPlan] = useState("");
	const [activePlan, setActivePlan] = useState("");
	const [updatePlanModalLoading, setUpdatePlanModalLoading] = useState(false);
	const [inventoryPlanToUpdate, setInventoryPlanToUpdate] = useState({});
	const [fillingDataModal, toggleFillingDataModal] = useState(false);
	const [noInitialPlanAttached, setNoInitialPlanAttached] = useState(true);
	const [confimrationScreen, setConfirmationNeeded] = useState(false);
	const [needsUpdate, setNeedsUpdate] = useState(false);

	async function getReplenishmentPlans() {
		const payload = {
			statuses: [1, 2, 3],
			restaurantId: machineID,
		};
		setPageError(false);
		setLoading(true);
		const response = await RepenishmentPlanService.getReplenishmentPlans(payload, activeRole);
		setLoading(false);
		const { data, error } = response;
		if (data) {
			setTaskList(data);
			setNeedsUpdate(false);
		}
		if (error) {
			errorNotification(error);
			setPageError(true);
		}
	}

	function renderAttachPlanComponent(taskData, { hasPermissionToReplace, hasPermissionToAttach }) {
		if (taskData.type === TaskTypes.UNDOCK_ALL) {
			return <>Not applicable</>;
		}

		if (!isEmpty(taskData?.inventoryPlan)) {
			let renderData = [],
				actionButtons = [];

			renderData.push(<>{taskData?.inventoryPlan?.name}</>);

			if (hasPermissionToReplace) {
				actionButtons.push(
					<Button
						onClick={() => {
							setNoInitialPlanAttached(false);
							setSelectedInventoryPlan(taskData?.inventoryPlan?._id);
							handleAttachPlanModalOpen(taskData.id);
						}}>
						Replace
					</Button>
				);
			}

			actionButtons.push(
				<Button
					onClick={() => {
						openFillingDataModal(taskData.inventoryPlan, taskData.id);
					}}>
					Update
				</Button>
			);

			renderData.push(<Block>{actionButtons}</Block>);

			return (
				<Div flexDirection="column" alignItem="center" jContent="center">
					{renderData}
				</Div>
			);
		} else {
			if (hasPermissionToAttach) {
				return <Button onClick={() => handleAttachPlanModalOpen(taskData.id)}>Attach Plan</Button>;
			}
		}
	}

	function renderTaskList(tasks) {
		if (tasks.length) {
			let tasksRenderData = tasks.map((task) => {
				const { id, startTime, endTime, type, taskName, status, assignee, inventoryPlan } = task;
				const endTimeString = endTime ? endTime : "-";
				const startTimeString = startTime ? startTime : "-";
				const hasPermissionToCancel = checkFunctionalityPermissions(activeRole, USER_FUNCTIONALITIES.CANCEL_PLAN);
				const hasPermissionToReplace = checkFunctionalityPermissions(activeRole, USER_FUNCTIONALITIES.REPLACE_PLAN);
				const hasPermissionToAttach = checkFunctionalityPermissions(activeRole, USER_FUNCTIONALITIES.ATTACH_TO_PLAN);

				return (
					<Trow hoverEffect={false}>
						<Tcol borderRadius="10px 0 0 10px">{id}</Tcol>
						<Tcol>{startTimeString}</Tcol>
						<Tcol>{endTimeString}</Tcol>
						<Tcol>{taskName}</Tcol>
						<Tcol>{assignee}</Tcol>
						<Tcol>{renderAttachPlanComponent(task, { hasPermissionToReplace, hasPermissionToAttach })}</Tcol>
						<Tcol>{status}</Tcol>
						<Tcol borderRadius="0 10px 10px 0">
							{hasPermissionToCancel ? (
								<Button
									onClick={() => {
										setPlanToCancelData({ id, status, taskName });
										showCancelModal(true);
									}}>
									Cancel
								</Button>
							) : (
								""
							)}
						</Tcol>
					</Trow>
				);
			});
			return (
				<Table>
					<Trow head>
						<Thead>ID</Thead>
						<Thead>Start Time</Thead>
						<Thead>End Time</Thead>
						<Thead>Type</Thead>
						<Thead>Assigned To</Thead>
						<Thead>Plan Name</Thead>
						<Thead>Status</Thead>
						<Thead></Thead>
					</Trow>
					<Tbody>{tasksRenderData}</Tbody>
				</Table>
			);
		} else {
			return <EmptyState message="No planned tasks are available" />;
		}
	}

	useEffect(() => {
		getReplenishmentPlans();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	async function fetchUsersToAssign() {
		const { data, error } = await RepenishmentPlanService.fetchUsersToAssign(machineID);
		if (data) {
			if (data.length) {
				const asigneeOptions = data.map(({ id, name }) => ({ value: id, head: name }));
				setPotentialAsignees(asigneeOptions);
			}
		}
		if (error) {
			toggleShowCreatePlanModal(false);
			errorNotification(error);
		}
		setCreateModalLoading(false);
	}

	async function fetchInventoryPlans() {
		const { data, error } = await InventoryPlanService.getInventoryPlans(machineID);
		if (data) {
			if (data.length) {
				const inventoryPlanOptions = data.map(({ _id, name }) => ({ value: _id, head: name }));
				setInventoryPlans(inventoryPlanOptions);
			}
		}
		if (error) {
			toggleAttachPlanModal(false);
			errorNotification(error);
		}
		setUpdatePlanModalLoading(false);
	}

	function handleCreatePlanModalOpen() {
		if (!potentialAsignees.length && !createModalLoading) {
			setCreateModalLoading(true);
			fetchUsersToAssign();
		}
		toggleShowCreatePlanModal(true);
	}

	function handleAttachPlanModalOpen(activePlan) {
		if (!inventoryPlans.length && !updatePlanModalLoading) {
			setUpdatePlanModalLoading(true);
			fetchInventoryPlans();
		}
		setActivePlan(activePlan);
		toggleAttachPlanModal(true);
	}

	function handleAttachPlanModalClose() {
		toggleAttachPlanModal(false);
		setSelectedInventoryPlan("");
		setActivePlan("");
		setNoInitialPlanAttached(true);
		setConfirmationNeeded(false);
	}

	async function cancelReplenishmentPlan() {
		const { data, error } = await RepenishmentPlanService.cancelReplenishmentPlan(planToCancelData);
		if (data) {
			successNotification(`Plan ${planToCancelData?.id || ""} cancelled`);
			setPlanToCancelData({});
			showCancelModal(false);
			getReplenishmentPlans();
		}
		if (error) {
			errorNotification(error);
		}
	}

	async function attachInventoryPlan() {
		const { data, error } = await RepenishmentPlanService.attachInventoryPlan({
			workflowId: activePlan,
			planId: selectedInventoryPlan,
		});
		if (data) {
			successNotification(`Plan ${activePlan || ""} updated`);
			toggleAttachPlanModal(false);
			setSelectedInventoryPlan("");
			setActivePlan("");
			setNoInitialPlanAttached(true);
			setConfirmationNeeded(false);
			getReplenishmentPlans();
		}
		if (error) {
			errorNotification(error);
		}
	}

	async function createReplenishmentPlan(payload, timezone) {
		setCreatePlanLoading(true);

		payload = {
			...payload,
			kioskId: machineID,
			taskGroup: "REPLENISHMENT_TASK", //Remove later
			replenishmentPlanId: " ", //Remove later
		};

		try {
			updatePayloadDates(payload, timezone);
		} catch(error) {
			console.error(error.message);
			errorNotification("Something went wrong in creating the replenishment plan");
			setCreatePlanLoading(false)
			return;
		}

		const { data, error } = await RepenishmentPlanService.createReplenishmentPlan(payload);
		if (data) {
			successNotification(`Success`);
			toggleShowCreatePlanModal(false);
			getReplenishmentPlans();
		}
		if (error) {
			errorNotification(error);
		}

		setCreatePlanLoading(false);
	}

	function renderAttachInventoryPlanModal({ selectedInventoryPlan, inventoryPlans, confimrationScreen, noInitialPlanAttached }) {
		if (confimrationScreen) {
			return (
				<Div width="100%" alignItem="center" flexDirection="column" gap="1.5rem" padding="1.5rem" flexWrap="wrap">
					<CenteredRow>
						<Block>
							<Div>
								Confirm setting {selectedInventoryPlan} as the inventory plan for {activePlan}
							</Div>
						</Block>
					</CenteredRow>
					<Div jContent="flex-end">
						<Div
							margin="0.5rem"
							onClick={() => {
								setConfirmationNeeded(false);
							}}>
							<Button>No</Button>
						</Div>
						<Div margin="0.5rem">
							<SuccessButton
								onClick={() => {
									attachInventoryPlan();
								}}>
								Yes
							</SuccessButton>
						</Div>
					</Div>
				</Div>
			);
		}

		return (
			<Div width="100%" alignItem="center" flexDirection="column" gap="1.5rem" padding="1.5rem" flexWrap="wrap">
				<CenteredRow>
					<Block>
						<Div width="8rem">Inventory Plan</Div>
						<Dropdown
							value={selectedInventoryPlan}
							optionsList={inventoryPlans}
							onChange={(val) => {
								setSelectedInventoryPlan(val);
							}}
						/>
					</Block>
				</CenteredRow>
				<Div jContent="flex-end">
					<Div
						margin="0.5rem"
						onClick={() => {
							handleAttachPlanModalClose();
						}}>
						<Button>Cancel</Button>
					</Div>
					<Div margin="0.5rem">
						<SuccessButton
							onClick={() => {
								noInitialPlanAttached ? attachInventoryPlan() : setConfirmationNeeded(true);
							}}>
							Confirm
						</SuccessButton>
					</Div>
				</Div>
			</Div>
		);
	}

	function renderCreatePlanModal({ potentialAsignees, TaskTypeOptions, createPlanLoading, timezone }) {
		const config = getPlanDataFormConfig({ potentialAsignees, TaskTypeOptions });

		return (
			<Form
				config={config}
				submitButtonLoading={createPlanLoading}
				onSubmit={(formData) => {
					createReplenishmentPlan(formData, timezone);
				}}
				onCancel={() => {
					toggleShowCreatePlanModal(false);
				}}
			/>
		);
	}

	function renderCancelPlanModal(planToCancelData, cancelModalVisible) {
		if (isEmpty(planToCancelData) && cancelModalVisible) {
			return;
		}

		const planId = `#${planToCancelData?.id || "-"}`;
		const taskName = planToCancelData?.taskName || "-";

		return (
			<>
				<Div borderRadius="10px 10px 0 0" background="rgba(45, 35, 66, 0.8)" color="#fff" padding="1rem" jContent="space-between">
					<Span fontSize="1.4rem">Cancel Plan {planId} </Span>
					<img
						style={{
							height: "1.5rem",
							filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
						}}
						src={close}
						alt="close"
						onClick={() => {
							showCancelModal(false);
						}}
					/>
				</Div>
				<Div flexDirection="column" padding="1rem" gap="1rem">
					<Div>
						Are you sure you want to cancel the {taskName} plan with Id {planId} ?
					</Div>
					<Div jContent="flex-end" gap="1rem">
						<Div
							onClick={() => {
								toggleShowCreatePlanModal(false);
							}}>
							<Button
								onClick={() => {
									showCancelModal(false);
								}}>
								Cancel
							</Button>
						</Div>
						<Div>
							<SuccessButton
								onClick={() => {
									cancelReplenishmentPlan();
								}}>
								Confirm
							</SuccessButton>
						</Div>
					</Div>
				</Div>
			</>
		);
	}

	function openFillingDataModal(inventoryPlan, workflowId) {
		setInventoryPlanToUpdate(inventoryPlan);
		setActivePlan(workflowId);
		toggleFillingDataModal(true);
	}

	function closeUpdateFillingDataModal() {
		toggleFillingDataModal(false);
		setInventoryPlanToUpdate({});
		setActivePlan("");
		if (needsUpdate) getReplenishmentPlans();
	}

	function renderHeader() {
		let renderData = [];

		const hasPermissionToCreatePlan = checkFunctionalityPermissions(activeRole, USER_FUNCTIONALITIES.CREATE_PLAN);
		if (hasPermissionToCreatePlan) {
			renderData.push(
				<Block>
					<Button onClick={() => handleCreatePlanModalOpen()}>Create Plan</Button>
				</Block>
			);
		}
		return (
			<SpacedRow>
				<Header>Workflow Manager</Header>
				{renderData}
			</SpacedRow>
		);
	}

	return (
		<Page>
			{renderHeader()}
			{!loading && !pageError ? renderTaskList(taskList) : ""}
			{loading ? (
				<CenteredContainer>
					<Loader />
				</CenteredContainer>
			) : (
				""
			)}
			{!loading && pageError ? <EmptyState message="Could not fetch plans." retry={getReplenishmentPlans} /> : ""}

			<CSSTransition in={showCreatePlanModal} timeout={300} classNames="fade" unmountOnExit>
				<Overlay>
					<Modal width="max-content">
						<Div
							borderRadius="10px 10px 0 0"
							background="rgba(45, 35, 66, 0.8)"
							color="#fff"
							padding="1rem"
							jContent="space-between">
							<Span fontSize="1.4rem">Create Plan</Span>
							<img
								style={{
									height: "1.5rem",
									filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									toggleShowCreatePlanModal(false);
								}}
							/>
						</Div>
						{createModalLoading ? (
							<CenteredContainer>
								<Loader />
							</CenteredContainer>
						) : (
							""
						)}
						{!createModalLoading ? <>{renderCreatePlanModal({ potentialAsignees, TaskTypeOptions, createPlanLoading, timezone })}</> : ""}
					</Modal>
				</Overlay>
			</CSSTransition>

			<CSSTransition in={cancelModal} timeout={300} classNames="fade" unmountOnExit onExited={() => setPlanToCancelData(null)}>
				<Overlay>
					<Modal>{renderCancelPlanModal(planToCancelData, cancelModal)}</Modal>
				</Overlay>
			</CSSTransition>

			<CSSTransition in={showAttachPlanModal} timeout={300} classNames="fade" unmountOnExit>
				<Overlay>
					<Modal>
						<Div
							borderRadius="10px 10px 0 0"
							background="rgba(45, 35, 66, 0.8)"
							color="#fff"
							padding="1rem"
							jContent="space-between">
							<Span fontSize="1.4rem">Attach Inventory Plan</Span>
							<img
								style={{
									height: "1.5rem",
									filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									handleAttachPlanModalClose();
								}}
							/>
						</Div>
						{updatePlanModalLoading ? (
							<CenteredContainer>
								<Loader />
							</CenteredContainer>
						) : (
							""
						)}
						{!updatePlanModalLoading ? (
							<>
								{renderAttachInventoryPlanModal({
									selectedInventoryPlan,
									inventoryPlans,
									confimrationScreen,
									noInitialPlanAttached,
								})}
							</>
						) : (
							""
						)}
					</Modal>
				</Overlay>
			</CSSTransition>

			<CSSTransition in={fillingDataModal} timeout={300} classNames="fade" unmountOnExit>
				<Overlay>
					<Modal width="80%">
						<Div background="rgba(45, 35, 66, 0.8)" color="#fff" padding="1rem" jContent="space-between">
							<Span fontSize="1.4rem">Update Filling Data</Span>
							<img
								style={{
									height: "1.5rem",
									filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									closeUpdateFillingDataModal();
								}}
							/>
						</Div>
						<UpdateInventoryPlan
							closeModal={closeUpdateFillingDataModal}
							inventoryPlan={inventoryPlanToUpdate}
							workflowId={activePlan}
							setNeedsUpdate={setNeedsUpdate}
						/>
					</Modal>
				</Overlay>
			</CSSTransition>
		</Page>
	);
};

const mapStateToProps = (state) => {
	const { task, landing } = state;
	return { ...task, ...landing };
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskManager);
